import { useLocation } from 'react-router-dom';
import { usePageContext } from '../../context/PageContext';
import { buildBreadcrumbs } from './breadcrumbs';
import Breadcrumbs from '../ui/Breadcrumbs';
import NavUserMenu from './NavUserMenu';
import NavbarQuickActions from './NavbarQuickActions';
import NotificationBell from './NotificationBell';

/** Height matches the sidebar brand row (h-16). */
export const APP_HEADER_HEIGHT_CLASS = 'h-16';

// Top context bar — breadcrumbs + optional page actions. Always visible.
export default function Header() {
  const location = useLocation();
  const { meta } = usePageContext();

  const crumbs =
    meta.breadcrumbs ||
    buildBreadcrumbs(location.pathname, meta.dynamicLabels || {});

  return (
    <header
      className={`shrink-0 ${APP_HEADER_HEIGHT_CLASS} flex items-center gap-3 px-4 sm:px-6 lg:px-8 border-b border-surface-200/70 bg-white no-print`}
    >
      <div className="flex-1 min-w-0">
        {crumbs.length > 0 ? (
          <Breadcrumbs items={crumbs} />
        ) : (
          <span className="text-sm font-medium text-dark-900">Dashboard</span>
        )}
      </div>
      <div className="flex items-center gap-3 sm:gap-4 shrink-0">
        <div className="hidden lg:block">
          <NavbarQuickActions />
        </div>
        <NotificationBell />
        {meta.headerAction && (
          <div className="hidden sm:flex items-center gap-2">{meta.headerAction}</div>
        )}
        <div className="hidden lg:block">
          <NavUserMenu />
        </div>
      </div>
    </header>
  );
}
